export default __webpack_public_path__ + "static/media/Slider_2500_Web.6bdfbfc1.webp";